const Base64Url = require('./Base64Url')
const createHmac = require('create-hmac')
const ORIGINAL_ATTR = 1
const ENCODED_ATTR = 2

class JWTGenerator {

    construct(props = [])
    {
        this.key = props['key'] ? props['key'] : null;
        this.headers['original'] = props['headers'] ? props['headers'] : [];
        this.payload['original'] = props['payload'] ? props['payload'] : [];
    }

    setKey(key)
    {
        this.key = key;
        return this;
    }

    setHeaders(headers)
    {
        this.headers['original'] = headers;
        return this;
    }
    
    setPayload(payload)
    {
        this.payload['original'] = payload;
        return this;
    }

    transformData(value, type)
    {
        if(Array.isArray(value))
        {
            value = JSON.stringify(value);
        }
        if(type === ENCODED_ATTR)
        {
            value = Base64Url.encode(value);
        }
        return value;
    }

    getHeaders(type)
    {
        return this.transformData(
            this.headers['original'],
            type
        )
    }

    getPayload($type)
    {
        return this.transformData(
            this.payload['original'],
            type
        );
    }

    getSignature(type)
    {
        this.headers['encoded'] = this.getHeaders(ENCODED_ATTR)
        this.payload['encoded'] = this.getPayload(ENCODED_ATTR)
        var hmac = createHmac('sha256', Buffer.from(this.key))       
        this.signature =  hmac.update("{"+this.headers['encoded']+"}.{"+this.payload['encoded']+"}")
        return this.transformData(this.signature, type);
    }
    
    getToken()
    {
        signature = this.getSignature(ENCODED_ATTR);
        token = this.headers['encoded'];
        token+= "." + this.payload['encoded'];
        token+= "." + signature;
        return token;
    }
}

module.exports = JWTGenerator